import { useEffect } from 'react';
import { useConfirmDialog } from '../components/ConfirmDialogProvider';
import { useBlocker } from 'react-router';
import { FormattedMessage } from 'react-intl';

const PromptDialog = ({ when }) => {
  const { promptConfirmation } = useConfirmDialog();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      when && currentLocation.pathname !== nextLocation.pathname
  );

  const confirmBeforeLeave = async () => {
    if (blocker.state === 'blocked') {
      await promptConfirmation({
        title: <FormattedMessage id="confirmBeforeLeave" />,
        onAccept: () => {
          blocker.proceed();
        },
        onCancel: () => {
          blocker.reset();
        },
      });
    }
  };

  useEffect(() => {
    if (blocker.state === 'blocked') {
      confirmBeforeLeave();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocker.state]);

  return null;
};

export default PromptDialog;
